// extracted by mini-css-extract-plugin
export default {"order__inputs":"OrderContacts_order__inputs__hbRtb"};